import React, { useState } from "react";
import { Grid } from 'semantic-ui-react'
import { InputField, DropDown } from 'KN-EU-Broker-Dashboard-UI'
import { countryList } from "../../../../util/countryList";
import DropDownLabel from "../../commonComponents/DropdownLabel";
import { dropdownLabelVal } from "../../../constants";

const EntryLineDetailsForm = ({formData}) => {
    const {parentEntryNumber, lineNumber, countryOfOrigin, orgHTSNumber, reconHTSNumber, orgMerchValue, reconMerchValue, orgRevenueDetails: {DUTY:{revenueAmount:orgDuty=""}={}, "HARBOR MAINTENANCE FEE":{revenueAmount:orgHmf=""}={}, "FORMAL MERCHANDISE PROCESSING FEE":{revenueAmount:orgMpf=""}={}}, reconRevenueDetails: {DUTY:{revenueAmount:reconDuty=""}={}, "HARBOR MAINTENANCE FEE":{revenueAmount:reconHmf=""}={}, "FORMAL MERCHANDISE PROCESSING FEE":{revenueAmount:reconMpf=""}={}}, orgSpecialProgramClaimCode} = formData;
    const { orgRevenueDetails, reconRevenueDetails } = formData;
    const orgDynamicField = Object.keys(orgRevenueDetails).filter((item) => {
        if(item !== "DUTY" && item !== "HARBOR MAINTENANCE FEE" && item !== "FORMAL MERCHANDISE PROCESSING FEE"){
            return item;
        }
    })
    return (
            <Grid.Row>
                <Grid.Column>
                    <InputField 
                        label="Entry No." 
                        value={parentEntryNumber}
                        isDisabled={true}
                    />
                </Grid.Column>
                <Grid.Column>
                    <InputField 
                        label="Line No." 
                        value={lineNumber}
                        isDisabled={true}
                    />
                </Grid.Column>
                <Grid.Column>
                    <DropDown 
                        label="COO" 
                        value={countryOfOrigin}
                        data={countryList}
                    />
                </Grid.Column>
                <Grid.Column>
                    <InputField 
                        label="SPI" 
                        value={orgSpecialProgramClaimCode}
                    />
                </Grid.Column>
                <Grid.Column>
                    <InputField 
                        label="HTS" 
                        value={orgHTSNumber}
                    />
                </Grid.Column>
                <Grid.Column>
                    <InputField 
                        label="Entered Val." 
                        value={orgMerchValue}
                    />
                </Grid.Column>
                <Grid.Column>
                    <InputField 
                        label="Recon Entered Val." 
                        value={reconMerchValue}
                    />
                </Grid.Column>
                <Grid.Column>
                    <InputField 
                        label="Duty" 
                        value={orgDuty}
                    />
                </Grid.Column>
                <Grid.Column>
                    <InputField 
                        label="Recon Duty" 
                        value={reconDuty}
                    />
                </Grid.Column>
                <Grid.Column>
                    <InputField 
                        label="MPF" 
                        value={orgMpf}
                    />
                </Grid.Column>
                <Grid.Column>
                    <InputField 
                        label="Recon MPF" 
                        value={reconMpf}
                    />
                </Grid.Column>
                <Grid.Column>
                    <InputField 
                        label="HMF" 
                        value={orgHmf}
                    />
                </Grid.Column>
                <Grid.Column>
                    <InputField 
                        label="Recon HMF" 
                        value={reconHmf}
                    />
                </Grid.Column>
                <Grid.Column>
                    <InputField 
                        labelClassName="dropdown-label"
                        label={<DropDownLabel value={orgDynamicField[0]} showLabel={true} data={dropdownLabelVal}/>} 
                        value={orgRevenueDetails[orgDynamicField[0]]?.revenueAmount}
                    />
                </Grid.Column>
                <Grid.Column>
                    <InputField
                        labelClassName="dropdown-label"
                        label={<>Recon <DropDownLabel value={orgDynamicField[0]} showLabel={true} data={dropdownLabelVal}/></>} 
                        value={reconRevenueDetails[orgDynamicField[0]]?.revenueAmount}
                    />
                </Grid.Column>
            </Grid.Row>
     );
}
 
export default React.memo(EntryLineDetailsForm);